import React, { Component, Fragment } from 'react';
import { Checkbox, Col, Form, InputNumber, Row, Select } from 'antd';

const Option = Select.Option;

export class BuyForm extends Component {
    render() {
        const { getFieldDecorator, getFieldValue } = this.props.form;
        const { mode } = this.props;
        const orderType = getFieldValue(`${mode}_order_type`);
        const type = getFieldValue(`${mode}_type`);

        if (getFieldValue('type') === 'adca') return null;

        return (
            <div>
                {getFieldValue('type') === 'buy_sell' || getFieldValue('type') === 'signal' ? (
                    <Row gutter={24}>
                        <Col md={12} style={{ paddingLeft: 12, paddingRight: 12 }}>
                            <Form.Item label="Entry type">
                                {getFieldDecorator(`${mode}_type`, {
                                    initialValue: 'last_tick'
                                })(
                                    <Select>
                                        <Option value="last_tick">Last Tick</Option>
                                        <Option value="trail">Trailing Buy</Option>
                                    </Select>
                                )}
                            </Form.Item>
                        </Col>

                        {this.renderBuyTrailFields()}
                    </Row>
                ) : null}

                <Row gutter={24}>
                    <Col md={12} style={{ paddingLeft: 12, paddingRight: 12 }}>
                        <Form.Item label="Order type">
                            {getFieldDecorator(`${mode}_order_type`, {
                                initialValue: 'limit'
                            })(
                                <Select>
                                    <Option value="market">Market</Option>
                                    <Option value="limit">Limit</Option>
                                </Select>
                            )}
                        </Form.Item>
                    </Col>

                    {this.renderLastTickFields(orderType)}

                    {orderType === 'limit' || type === 'trail' ? (
                        <Col md={12} style={{ paddingLeft: 12, paddingRight: 12 }}>
                            <Form.Item label="Length of time an order should be open (minutes)">
                                {getFieldDecorator(`${mode}_order_open_time`, {
                                    rules: [{ required: true, message: 'Field is required' }],
                                    initialValue: 5
                                })(<InputNumber addonAfter="minutes" />)}
                            </Form.Item>
                        </Col>
                    ) : null}

                    {this.renderBuyFields()}
                    {this.renderRbFields()}
                </Row>
            </div>
        );
    }

    renderBuyFields() {
        const { getFieldDecorator, getFieldValue } = this.props.form;
        const { mode } = this.props;

        if (getFieldValue('type') === 'buy_sell') {
            return (
                <Fragment>
                    <Col sm={12} md={12} style={{ paddingLeft: 12, paddingRight: 12 }}>
                        <Form.Item label="Cooldown period (minutes)">
                            {getFieldDecorator(`${mode}_cooldown_period`, {
                                rules: [{ required: true, message: 'Field is required' }],
                                initialValue: 25
                            })(<InputNumber addonAfter="minutes" />)}
                        </Form.Item>
                    </Col>

                    <Col sm={12} md={12} style={{ paddingLeft: 12, paddingRight: 12 }}>
                        <Form.Item
                            label="Evolve time (minutes)"
                            extra={'On partial fills how long to wait before we try to sell'}
                        >
                            {getFieldDecorator(`${mode}_order_evolve_time`, {
                                rules: [{ required: true, message: 'Field is required' }],
                                initialValue: 5
                            })(<InputNumber />)}
                        </Form.Item>
                    </Col>
                </Fragment>
            );
        }
        return null;
    }

    renderRbFields() {
        const { getFieldDecorator, getFieldValue } = this.props.form;
        const { mode } = this.props;
        const rebuyAboveEnabled = getFieldValue(`${mode}_rebuy_above_last_sell_enabled`);
        const rebuyBelowEnabled = getFieldValue(`${mode}_rebuy_below_last_sell_enabled`);

        if (getFieldValue('type') === 'art') {
            return (
                <Fragment>
                    <Col md={4} style={{ paddingLeft: 12, paddingRight: 12 }}>
                        <Form.Item label="Cooldown period (minutes)">
                            {getFieldDecorator(`${mode}_cooldown_period`, {
                                rules: [{ required: true, message: 'Field is required' }],
                                initialValue: 25
                            })(<InputNumber addonAfter="minutes" />)}
                        </Form.Item>
                    </Col>

                    <Col md={4} style={{ paddingLeft: 12, paddingRight: 12 }}>
                        <Form.Item label="Only buy below last sell price">
                            {getFieldDecorator(`${mode}_only_buy_below_last_sell_enabled`, {
                                initialValue: false,
                                valuePropName: 'checked'
                            })(<Checkbox />)}
                        </Form.Item>
                    </Col>

                    <Col md={4} style={{ paddingLeft: 12, paddingRight: 12 }}>
                        <Form.Item label="Auto Rebuy above last sell price">
                            {getFieldDecorator(`${mode}_rebuy_above_last_sell_enabled`, {
                                initialValue: false,
                                valuePropName: 'checked'
                            })(<Checkbox />)}
                        </Form.Item>
                    </Col>

                    {rebuyAboveEnabled ? (
                        <Col md={4} style={{ paddingLeft: 12, paddingRight: 12 }}>
                            <Form.Item
                                label="Rebuy at n%"
                                extra={'Rebuy once price rises n% above last sell'}
                            >
                                {getFieldDecorator(`${mode}_rebuy_above_last_sell_percent`, {
                                    initialValue: 0
                                })(<InputNumber addonAfter="%" />)}
                            </Form.Item>
                        </Col>
                    ) : null}

                    <Col md={4} style={{ paddingLeft: 12, paddingRight: 12 }}>
                        <Form.Item label="Auto Rebuy below n%">
                            {getFieldDecorator(`${mode}_rebuy_below_last_sell_enabled`, {
                                initialValue: false,
                                valuePropName: 'checked'
                            })(<Checkbox />)}
                        </Form.Item>
                    </Col>

                    {rebuyBelowEnabled ? (
                        <Col md={4} style={{ paddingLeft: 12, paddingRight: 12 }}>
                            <Form.Item
                                label="Rebuy at n%"
                                extra={'Rebuy once price drops n% from reverse sell price'}
                            >
                                {getFieldDecorator(`${mode}_rebuy_below_last_sell_percent`, {
                                    initialValue: 0
                                })(<InputNumber addonAfter="%" />)}
                            </Form.Item>
                        </Col>
                    ) : null}
                </Fragment>
            );
        }
        return null;
    }

    renderLastTickFields() {
        const { getFieldDecorator, getFieldValue } = this.props.form;
        const { mode } = this.props;
        if (
            getFieldValue('buy_type') === 'trail' ||
            getFieldValue(`${mode}_order_type`) === 'market'
        )
            return null;

        return (
            <Col sm={12} md={12} style={{ paddingLeft: 12, paddingRight: 12 }}>
                <Form.Item label="Offset the calculated buy price by n%">
                    {getFieldDecorator(`${mode}_price_offset`, {
                        rules: [{ required: true, message: 'Field is required' }],
                        initialValue: 0
                    })(<InputNumber addonAfter="%" />)}
                </Form.Item>
            </Col>
        );
    }

    renderBuyTrailFields() {
        const { getFieldDecorator, getFieldValue } = this.props.form;
        const { mode } = this.props;
        if (getFieldValue(`${mode}_type`) === 'trail') {
            return (
                <React.Fragment>
                    <Col sm={12} md={12} style={{ paddingLeft: 12, paddingRight: 12 }}>
                        <Form.Item label="Targeted On">
                            {getFieldDecorator(`${mode}_trail_target`, {
                                initialValue: 'price'
                            })(
                                <Select>
                                    <Option value="price">Price</Option>
                                </Select>
                            )}
                        </Form.Item>
                    </Col>

                    <Col sm={12} md={12} style={{ paddingLeft: 12, paddingRight: 12 }}>
                        <Form.Item
                            label="Price buffer (percent)"
                            extra={
                                <span>
                                    Price must first drop by n% before a <b>buy trigger</b> can be
                                    registered
                                </span>
                            }
                        >
                            {getFieldDecorator(`${mode}_trail_arm`, {
                                rules: [{ required: true, message: 'Field is required' }],
                                initialValue: 0
                            })(<InputNumber addonAfter="%" />)}
                        </Form.Item>
                    </Col>

                    <Col sm={12} md={12} style={{ paddingLeft: 12, paddingRight: 12 }}>
                        <Form.Item
                            label="Buy trigger (percent)"
                            extra="Trigger a buy when price rises n%"
                        >
                            {getFieldDecorator(`${mode}_trail_stop_loss`, {
                                rules: [{ required: true, message: 'Field is required' }],
                                initialValue: 0.2
                            })(<InputNumber addonAfter="%" />)}
                        </Form.Item>
                    </Col>
                </React.Fragment>
            );
        }
        return null;
    }
}



// WEBPACK FOOTER //
// ./src/Account/Strategies/Standard/Shared/BuyForm.js